<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import HotelDetails from "@/components/hotel/HotelDetails";

// Dashboard Component

export default {
  page: {
    title: "Hotel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    HotelDetails,
  },
  data() {
    return {
      title: "Hotel",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Hotel",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <HotelDetails />
  </div>
</template>
